import React from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import useTiCoreApi from "./useTiCoreApi";
import LoadingAndErrorHandling from "../../commons/LoadingAndErrorHandling";
import LoadingOverlay from "../../../components/LoadingOverlay";

const TiCoreMetadataWrapper = ({
  Component,
  apiFields,
  filter,
  showLoadingOverlay,
  responseTransformation = response => response,
  sha1,
  additionalProps
}) => {
  const hash = sha1 || useParams().hash;
  const [response, error, loading] = useTiCoreApi(hash, apiFields, filter);
  return (
    <LoadingAndErrorHandling
      error={error}
      loading={loading && !showLoadingOverlay}
    >
      {showLoadingOverlay && loading && <LoadingOverlay />}
      <Component {...responseTransformation(response)} {...additionalProps} />
    </LoadingAndErrorHandling>
  );
};

TiCoreMetadataWrapper.propTypes = {
  Component: PropTypes.func.isRequired,
  apiFields: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]).isRequired,
  filter: PropTypes.shape({}),
  showLoadingOverlay: PropTypes.bool,
  responseTransformation: PropTypes.func,
  sha1: PropTypes.string,
  additionalProps: PropTypes.shape({})
};

export default TiCoreMetadataWrapper;
